module.exports = __webpack_public_path__ + "img/serviceEcology.696f074b.png";